var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.4619 24.0517H50.6809C51.8353 24.0517 52.7711 24.9896 52.7711 26.1465V37.3009C52.7711 41.553 49.3317 45 45.089 45H45.0527C40.81 45.0006 37.3701 41.5541 37.3695 37.302C37.3695 37.3017 37.3695 37.3013 37.3695 37.3009V25.1465C37.3695 24.5419 37.8586 24.0517 38.4619 24.0517Z",
    fill: "#5059C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7672 21.9828C49.5064 21.9828 51.727 19.7249 51.727 16.9396C51.727 14.1544 49.5064 11.8965 46.7672 11.8965C44.0279 11.8965 41.8073 14.1544 41.8073 16.9396C41.8073 19.7249 44.0279 21.9828 46.7672 21.9828Z",
    fill: "#5059C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1045 21.9827C35.1412 21.9827 38.4137 18.7406 38.4137 14.7413C38.4137 10.742 35.1412 7.49994 31.1045 7.49994C27.0677 7.49994 23.7952 10.742 23.7952 14.7413C23.7952 18.7406 27.0677 21.9827 31.1045 21.9827Z",
    fill: "#7B83EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8041 24.0517H20.3606C19.2045 24.0801 18.2899 25.0325 18.3168 26.1803V38.9527C18.1553 45.8401 23.6444 51.5556 30.5824 51.7241C37.5203 51.5556 43.0094 45.8401 42.848 38.9527V26.1803C42.8748 25.0325 41.9602 24.0801 40.8041 24.0517Z",
    fill: "#7B83EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.6265 24.0517V41.9409C31.621 42.7613 31.1225 43.4983 30.3618 43.8106C30.1196 43.9128 29.8593 43.9654 29.5964 43.9655H19.2901C19.1459 43.6004 19.0128 43.2353 18.9018 42.8592C18.5135 41.5897 18.3154 40.27 18.3139 38.9428V26.1758C18.2872 25.0305 19.1956 24.0801 20.344 24.0517H31.6265Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5824 24.0517V42.9823C30.5823 43.2437 30.5292 43.5024 30.4262 43.7431C30.1113 44.4991 29.3684 44.9945 28.5413 45H19.8196C19.63 44.6361 19.4515 44.2723 19.2954 43.8974C19.1392 43.5226 19.0165 43.1698 18.905 42.7949C18.5146 41.5298 18.3154 40.2146 18.3139 38.8919V26.1686C18.2871 25.0272 19.2003 24.08 20.3549 24.0517H30.5824Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5824 24.0517V40.8987C30.5739 42.0176 29.665 42.9225 28.5413 42.931H18.905C18.5146 41.6567 18.3154 40.332 18.3139 38.9997V26.1839C18.2871 25.0343 19.2003 24.0802 20.3549 24.0517H30.5824Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.5382 24.0517V40.8987C29.5296 42.0176 28.615 42.9225 27.4841 42.931H18.9088C18.5159 41.6567 18.3154 40.332 18.3139 38.9997V26.1839C18.2869 25.0343 19.206 24.0802 20.3679 24.0517H29.5382Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M31.6266 18.3755V21.96C31.4378 21.9714 31.2603 21.9827 31.0715 21.9827C30.8828 21.9827 30.7052 21.9714 30.5165 21.96C30.1419 21.9345 29.7703 21.8735 29.4065 21.7779C27.1587 21.2322 25.3017 19.6162 24.4115 17.431C24.2583 17.0641 24.1394 16.683 24.0563 16.2931H29.5952C30.7153 16.2974 31.6223 17.2272 31.6266 18.3755Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5824 19.3491V21.7241C30.1979 21.6994 29.8166 21.6402 29.4433 21.5474C27.1366 21.0176 25.2309 19.4488 24.3173 17.3276H28.4978C29.6473 17.3318 30.578 18.2344 30.5824 19.3491Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30.5824 19.3491V21.7241C30.1979 21.6994 29.8166 21.6402 29.4433 21.5474C27.1366 21.0176 25.2309 19.4488 24.3173 17.3276H28.4978C29.6473 17.3318 30.578 18.2344 30.5824 19.3491Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.5382 19.4338V21.7241C27.1888 21.1722 25.2478 19.5377 24.3173 17.3276H27.415C28.5858 17.332 29.5338 18.2724 29.5382 19.4338Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04453 17.3276H27.4937C28.6229 17.3276 29.5382 18.2441 29.5382 19.3746V39.8495C29.5382 40.9801 28.6229 41.8965 27.4937 41.8965H7.04453C5.91539 41.8965 5.00006 40.98 5.00006 39.8495V19.3746C5.00006 18.2441 5.91541 17.3276 7.04453 17.3276Z",
    fill: "url(#paint0_linear_7600_184863)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.49 25.1601H18.4243V36.2069H15.8341V25.1601H11.7872V23.0172H22.49V25.1601Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7600_184863",
    x1: 9.26284,
    y1: 15.7281,
    x2: 25.3056,
    y2: 43.4787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A62C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4D55BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940AB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/teams.ae2f4e3b029a22cfd62a6f48bcb90e89.svg";
export { ForwardRef as ReactComponent };